import React from 'react';
import { DrunkCard } from './DrunkCard';

export const MODES = {
  drunk_ai: {
    name: "Drunk AI",
    emoji: "🍺",
    vibe: "Chaotic party buddy. No judgment, all ideas tracked.",
    colors: {
      primary: "bg-pink",
      secondary: "bg-cyan", 
      accent: "bg-yellow",
      gradient: "from-pink to-cyan"
    },
    setupQuestions: [
      "What's the occasion tonight?",
      "How many people are with you?",
      "Any topics you want to brainstorm?"
    ]
  },
  party: {
    name: "Party Buddy",
    emoji: "🎉",
    vibe: "Fun & energetic. Capture the laughs and highlights.",
    colors: {
      primary: "bg-orange-500",
      secondary: "bg-pink",
      accent: "bg-yellow",
      gradient: "from-orange-500 to-pink"
    },
    setupQuestions: [
      "What kind of party is this?",
      "Any special theme?",
      "What's the vibe you're going for?"
    ]
  },
  keepsake: {
    name: "Keepsake",
    emoji: "💝",
    vibe: "Sweet & sentimental. Capture wishes, advice, and heartfelt moments.",
    colors: {
      primary: "bg-rose-400",
      secondary: "bg-purple-300",
      accent: "bg-rose-200",
      gradient: "from-rose-400 to-purple-300"
    },
    setupQuestions: [
      "What's the special occasion?",
      "Who is being celebrated?",
      "Any message you want guests to focus on?"
    ]
  },
  roadtrip: {
    name: "Road Trip Buddy",
    emoji: "🚗",
    vibe: "Adventure buddy. Track stops, stories, and 'we made it!' moments.",
    colors: {
      primary: "bg-emerald-500",
      secondary: "bg-sky-400",
      accent: "bg-amber-400",
      gradient: "from-emerald-500 to-sky-400"
    },
    setupQuestions: [
      "Where are you headed?",
      "How long is the trip?",
      "Who's coming along?"
    ]
  },
  event: {
    name: "Event Log",
    emoji: "📋",
    vibe: "Organized & useful. Track highlights and key moments.",
    colors: {
      primary: "bg-indigo-500",
      secondary: "bg-slate-400",
      accent: "bg-indigo-200",
      gradient: "from-indigo-500 to-slate-400"
    },
    setupQuestions: [
      "What type of event is this?",
      "What's the main purpose?",
      "Any key topics to capture?"
    ]
  }
};

export const ModeSelector = ({ selectedMode, onSelectMode }) => {
  const modes = Object.entries(MODES);

  return (
    <div className="space-y-3">
      {modes.map(([key, mode]) => (
        <div
          key={key}
          onClick={() => onSelectMode(key)}
          className={`cursor-pointer transition-all ${
            selectedMode === key ? 'scale-[1.02]' : 'hover:scale-[1.01]'
          }`}
          data-testid={`mode-${key}`}
        >
          <DrunkCard 
            variant={selectedMode === key ? "default" : "default"}
            className={`p-4 ${
              selectedMode === key 
                ? `ring-4 ring-black ${mode.colors.primary} ${key === 'keepsake' ? 'text-black' : 'text-white'}`
                : 'bg-white'
            }`}
          >
            <div className="flex items-start gap-3">
              <span className="text-3xl">{mode.emoji}</span>
              <div className="flex-1">
                <h3 className="font-heading text-lg font-bold">{mode.name}</h3>
                <p className={`font-body text-sm ${selectedMode === key ? 'opacity-90' : 'text-black/70'}`}>
                  {mode.vibe}
                </p>
              </div>
              {selectedMode === key && (
                <span className="text-2xl">✓</span>
              )}
            </div>
          </DrunkCard>
        </div>
      ))}
    </div>
  );
};

export default ModeSelector;
